<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>
         <v-row dense>
            <v-col cols="12" v-if="memberinfo">
               <div class="member-info-shell">
                  <div class="member-info-hero">
                     <div class="member-profile">
                        <v-avatar size="86" class="member-avatar">
                           <v-img :src="previewphoto || '/images/logo-icon.png'" :alt="memberTitle" />
                        </v-avatar>
                        <div>
                           <div class="overline white--text text--lighten-3 mb-1">Membership Profile</div>
                           <h2 class="member-name">{{ memberTitle }}</h2>
                           <div class="member-meta">
                              <span>{{ formmodel.sectdetails.contactemail || '-' }}</span>
                              <span>{{ formmodel.sectdetails.contactmobile || '-' }}</span>
                           </div>
                           <div class="mt-3">
                              <v-chip small dark class="mr-2" :color="memberTypeColor">{{ memberTypeLabel }}</v-chip>
                              <v-chip small dark :color="memberStatusColor">{{ memberStatusLabel }}</v-chip>
                           </div>
                        </div>
                     </div>
                     <div class="member-actions">
                        <v-btn v-if="canRequestCorporateUpgrade" outlined dark href="/member/corporate-upgrade">
                           <v-icon left>mdi-arrow-up-bold-box</v-icon>
                           {{ parseInt(memberinfo.applcorpstatus || 0) === 5 ? 'Continue Corporate Upgrade' : 'Upgrade to Corporate' }}
                        </v-btn>
                        <v-btn color="white" class="primary--text" @click="updatemember" :disabled="photoValidating || photoValidationState === 'error'">
                           <v-icon left>mdi-content-save</v-icon>
                           Save Changes
                        </v-btn>
                     </div>
                  </div>

                  <div class="member-summary-grid">
                     <div class="summary-tile">
                        <span>Member ID</span>
                        <strong>{{ formmodelgeneral.memberid || 'Not assigned' }}</strong>
                     </div>
                     <div class="summary-tile">
                        <span>Valid Until</span>
                        <strong>{{ formmodelgeneral.datevalid || '-' }}</strong>
                     </div>
                     <div class="summary-tile">
                        <span>LPBM No.</span>
                        <strong>{{ lpbmDisplay }}</strong>
                     </div>
                     <div class="summary-tile">
                        <span>Profile Completion</span>
                        <strong>{{ profileCompletion }}%</strong>
                        <v-progress-linear :value="profileCompletion" height="5" rounded color="primary" class="mt-2"></v-progress-linear>
                     </div>
                  </div>

                  <v-tabs v-model="tab" class="member-tabs" show-arrows>
                     <v-tab key="T1"><v-icon left small>mdi-view-dashboard-outline</v-icon>General</v-tab>
                     <v-tab key="T2"><v-icon left small>mdi-account-edit-outline</v-icon>Details</v-tab>
                     <v-tab key="T3"><v-icon left small>mdi-school-outline</v-icon>Qualification</v-tab>
                     <v-tab key="T4" v-if="(memberinfo) ? (memberinfo.membertype !== 'STU') : false"><v-icon left small>mdi-briefcase-outline</v-icon>Employment</v-tab>
                     <v-tab key="T5" v-if="(memberinfo) ? (memberinfo.membertype === 'COR') : false"><v-icon left small>mdi-domain</v-icon>Corporate Experience</v-tab>
                     <v-tab key="T6"><v-icon left small>mdi-file-sign</v-icon>Declaration</v-tab>
                     <v-tab key="T7"><v-icon left small>mdi-credit-card-outline</v-icon>Payments</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                     <v-tab-item key="T1">
                        <div class="member-tab-panel">
                           <v-row dense>
                              <v-col cols="12" md="4" v-for="item in generalCards" :key="item.label">
                                 <div class="info-block">
                                    <div class="info-block-icon"><v-icon>{{ item.icon }}</v-icon></div>
                                    <div>
                                       <span>{{ item.label }}</span>
                                       <strong>{{ item.value }}</strong>
                                    </div>
                                 </div>
                              </v-col>
                           </v-row>
                           <div class="section-title">Membership Timeline</div>
                           <v-row dense>
                              <v-col cols="12" md="3" v-for="item in timelineCards" :key="item.label">
                                 <div class="timeline-block">
                                    <span>{{ item.label }}</span>
                                    <strong>{{ item.value }}</strong>
                                 </div>
                              </v-col>
                           </v-row>
                        </div>
                     </v-tab-item>
                     <v-tab-item key="T2">
                        <div class="member-tab-panel">
                        <v-row dense>
                           <v-col cols="12" md="9">
                              <v-form v-model="isvaliddetails">
                                 <v-jsf v-model="formmodel" :schema="formschema" :options="formoptions">
                                 </v-jsf>
                              </v-form>
                           </v-col>
                           <v-col cols="12" md="3" class="text-center pa-4">
                              <v-avatar size="180">
                                 <v-img
                                    :src="previewphoto"
                                    :alt="formmodel.sectdetails.fullname"
                                 />
                              </v-avatar>
                              <v-file-input
                                 ref="photofile"
                                 prepend-icon="mdi-camera"
                                 show-size
                                 v-model="photofile"
                                 accept="image/png, image/jpeg, image/bmp"
                                 placeholder="Pick a photo"
                                 :error-messages="photoValidationState === 'error' ? [photoValidationMessage] : []"
                                 @change="validateSelectedPhoto"
                              />
                              <div class="caption grey--text mt-1">
                                 JPG/PNG/BMP, max 1MB. Single-person portrait professional photo only. Group photos, selfies, screenshots, and documents are not accepted.
                              </div>
                              <div class="caption mt-2" :class="photoValidationClass" v-if="photoValidationMessage">
                                 {{ photoValidationMessage }}
                              </div>
                              <div class="caption red--text mt-2" v-if="!previewphoto">
                                 Professional photo is required for membership application.
                              </div>
                           </v-col>
                        </v-row>
                        </div>
                     </v-tab-item>
                     <v-tab-item key="T3">
                        <table-qual-edu ref="qualedu" v-on:QualEduMounted="onQualEduMounted"></table-qual-edu>
                        <v-divider v-if="(memberinfo) ? (memberinfo.membertype !== 'STU') : false"></v-divider>
                        <table-qual-pro ref="qualpro" v-if="(memberinfo) ? (memberinfo.membertype !== 'STU') : false" v-on:QualProMounted="onQualProMounted"></table-qual-pro>
                        <v-divider v-if="(memberinfo) ? (memberinfo.membertype === 'STU') : false"></v-divider>
                        <table-qual-stu ref="qualstu" v-if="(memberinfo) ? (memberinfo.membertype === 'STU') : false" v-on:QualStuMounted="onQualStuMounted"></table-qual-stu>
                     </v-tab-item>
                     <v-tab-item key="T4" v-if="(memberinfo) ? (memberinfo.membertype !== 'STU') : false">
                        <table-emp-exp ref="empexp" v-on:EmpExpMounted='onEmpExpMounted'></table-emp-exp>
                        <v-divider></v-divider>
                        <table-emp-cat ref="empcat" v-on:EmpCatUpdated="onEmpCatUpdated" v-on:EmpCatMounted="onEmpCatMounted"></table-emp-cat>
                     </v-tab-item>
                     <v-tab-item key="T5" v-if="(memberinfo) ? (memberinfo.membertype === 'COR') : false">
                        <table-corp-exp ref="corpexp" v-on:CorpExpCompleted="onCorpExpCompleted" v-on:CorpExpMounted="onCorpExpMounted"></table-corp-exp>
                     </v-tab-item>
                     <v-tab-item key="T6">
                        <table-decl-read-only ref="decl" v-on:DeclMounted="onDeclMounted"></table-decl-read-only>
                     </v-tab-item>
                     <v-tab-item key="T7">
                        <table-payment ref="payment" v-on:PaymentMounted="onPaymentMounted"></table-payment>
                     </v-tab-item>
                  </v-tabs-items>
               </div>
            </v-col>
            <v-col cols="12" v-else-if="isloading">
               <v-card class="pa-4">
                  <div class="d-flex align-center">
                     <v-progress-circular indeterminate color="primary" size="22" width="3" class="mr-3"></v-progress-circular>
                     <span>Loading membership information...</span>
                  </div>
               </v-card>
            </v-col>
            <v-col cols="12" v-else>
               <v-alert type="info" dense text>
                  You have to be registered as MIP Member in order to view your membership details.
               </v-alert>
            </v-col>
         </v-row>
      </v-container>
      <v-dialog v-model="dlgupgrade" max-width="520px">
         <v-card>
            <v-card-title>Upgrade to Corporate</v-card-title>
            <v-card-text>
               <p>This will submit your Graduate to Corporate upgrade request for admin approval.</p>
               <v-text-field v-model="upgradeForm.course_date" label="Course Date" type="date" dense outlined></v-text-field>
               <v-text-field v-model="upgradeForm.interview_date" label="Interview Date" type="date" dense outlined></v-text-field>
               <v-text-field v-model="upgradeForm.exam_date" label="Exam Date" type="date" dense outlined></v-text-field>
               <v-textarea v-model="upgradeForm.notes" label="Notes" dense outlined rows="3"></v-textarea>
               <v-file-input v-model="upgradeForm.document" label="Attach Support Document" accept=".jpg, .jpeg, .png, .pdf" show-size dense outlined></v-file-input>
               <v-alert type="info" dense text>
                  After submission, complete Corporate Experience and Declaration so proposer and seconder can approve the request.
               </v-alert>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="primary" text @click="dlgupgrade = false">Cancel</v-btn>
               <v-btn color="primary" :disabled="submittingUpgrade" @click="requestCorporateUpgrade">Submit Request</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
      <v-snackbar v-model="sbmessage" color="blue darken-3" timeout="2000" dark top>
      {{ txtmessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="sbmessage = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
   </dashboard-layout>
</template>

<script>
const axios = require('axios')
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import VJsf from '@koumoul/vjsf/lib/VJsf.js'
import '@koumoul/vjsf/lib/VJsf.css'
import '@koumoul/vjsf/lib/deps/third-party.js'
import PersonalDetailsModel from './Forms/PersonalDetailsModel.js'
import PersonalDetailsSchema from './Forms/PersonalDetailsSchema.js'
import MemberGeneralModel from './Forms/MemberGReadOnlyModel.js'
import MemberGeneralSchema from './Forms/MemberGReadOnlySchema.js'
import GeneralOptions from './Forms/GeneralOptions.js'
import TableQualEdu from './Tables/TableQualEdu.vue'
import TableQualPro from './Tables/TableQualPro.vue'
import TableQualStu from './Tables/TableQualStu.vue'
import TableEmpExp from './Tables/TableEmpExp.vue'
import TableEmpCat from './Tables/TableEmpCat.vue'
import TableCorpExp from './Tables/TableCorpExp.vue'
import TableDeclReadOnly from './Tables/TableDeclReadOnly.vue'
import TablePayment from './Tables/TablePaymentSF.vue'
import { validateProfessionalPhoto } from '../utils/professionalPhotoValidator.js'

export default {
   name: "MOMInfo",
   props: {
      user: Object,
   },
   components: {
      DashboardLayout,
      BaseBreadcrumb,
      TableQualEdu,
      TableQualPro,
      TableQualStu,
      TableEmpExp,
      TableEmpCat,
      TableCorpExp,
      TableDeclReadOnly,
      TablePayment,
      VJsf,
   },

   data: () => ({
      page: { title: "Membership Information" },
      breadcrumbs: [
         { text: "Dashboard", disabled: false, to: "/dashboard" },
         { text: "Membership Information", disabled: true },
      ],
      memberinfo: null,
      formmodel: PersonalDetailsModel,
      formschema: PersonalDetailsSchema,
      formoptions: GeneralOptions,
      formmodelgeneral: MemberGeneralModel,
      formschemageneral: MemberGeneralSchema,
      isvalidgeneral: false,
      isvaliddetails: false,
      tab: 'T1',
      photofile: null,
      previewphoto: null,
      photoValidationMessage: '',
      photoValidationState: '',
      photoValidating: false,
      photoResetting: false,
      sbmessage: false,
      txtmessage: '',
      isloading: true,
      autosaveTimer: null,
      autosaving: false,
      dlgupgrade: false,
      submittingUpgrade: false,
      upgradeForm: {
         course_date: '',
         interview_date: '',
         exam_date: '',
         notes: '',
         document: null,
      },
   }),

   watch: {
      'formmodel.sectdetails.icpassport': function (newval) {
         const formatted = this.formatIcPassport(newval)
         if (formatted !== newval) {
            this.formmodel.sectdetails.icpassport = formatted
            return
         }
         this.applyDobFromIc(newval, true)
      },

      formmodel: {
         deep: true,
         handler() {
            this.scheduleAutosave()
         }
      },
      photofile: function (newval) {
         if (this.photoResetting) {
            this.photoResetting = false
            return
         }
         this.validateSelectedPhoto(newval)
      },
   },

   methods: {
      formatIcPassport(value) {
         const current = String(value || '').trim()
         if (/[A-Za-z]/.test(current)) {
            return current
         }

         const digits = current.replace(/\D/g, '').slice(0, 12)
         if (digits.length <= 6) {
            return digits
         }
         if (digits.length <= 8) {
            return `${digits.slice(0, 6)}-${digits.slice(6)}`
         }
         return `${digits.slice(0, 6)}-${digits.slice(6, 8)}-${digits.slice(8)}`
      },

      async validateSelectedPhoto(file) {
         this.photoValidationMessage = ''
         this.photoValidationState = ''

         if (!file) {
            return true
         }

         this.previewphoto = URL.createObjectURL(file)
         this.photoValidating = true
         this.photoValidationMessage = 'Checking professional photo...'
         this.photoValidationState = 'info'

         try {
            const result = await validateProfessionalPhoto(file)
            if (!result.valid) {
               this.photoValidationMessage = result.message
               this.photoValidationState = 'error'
               this.photoResetting = true
               this.photofile = null
               this.previewphoto = null
               return false
            }

            this.photoValidationMessage = result.message
            this.photoValidationState = 'success'
            return true
         } catch (error) {
            this.photoValidationMessage = error.message || 'Unable to validate photo.'
            this.photoValidationState = 'error'
            this.photoResetting = true
            this.photofile = null
            this.previewphoto = null
            return false
         } finally {
            this.photoValidating = false
         }
      },

      applyDobFromIc(value, force = false) {
         const dob = this.dobFromMalaysianIc(value)
         if (!dob) {
            return
         }

         if (force || !this.formmodel.sectdetails.dob) {
            this.formmodel.sectdetails.dob = dob
         }
         this.formmodel.sectdetails.age = this.calculateAge(dob)
      },

      dobFromMalaysianIc(value) {
         const digits = String(value || '').replace(/\D/g, '')
         if (digits.length < 6) {
            return null
         }

         const yy = parseInt(digits.substring(0, 2), 10)
         const mm = parseInt(digits.substring(2, 4), 10)
         const dd = parseInt(digits.substring(4, 6), 10)
         const currentYear = new Date().getFullYear()
         const currentYY = currentYear % 100
         const year = yy <= currentYY ? 2000 + yy : 1900 + yy
         const date = new Date(year, mm - 1, dd)

         if (date.getFullYear() !== year || date.getMonth() !== mm - 1 || date.getDate() !== dd) {
            return null
         }

         return `${year}-${String(mm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`
      },

      calculateAge(dateString) {
         const today = new Date()
         const birthDate = new Date(dateString)
         let age = today.getFullYear() - birthDate.getFullYear()
         const monthDiff = today.getMonth() - birthDate.getMonth()

         if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--
         }

         return age
      },

      initialize() {
         this.$nextTick( function () {
            this.isloading = true
            if (!this.user || !this.user.id) {
               this.isloading = false
               return
            }
            var targetPath = '/member/info/' + this.user.id
            axios.get(targetPath)
            .then((resp) => {
               if (resp.data) {
                  var rtn = resp.data
                  if (rtn.status === 'OK') {
                     this.memberinfo = rtn.data || null
                     if (this.memberinfo) {
                        this.loadform(this.memberinfo)
                     }
                  } else {
                     console.log(rtn.status + ': ' + rtn.error)
                  }
               }
            })
            .catch((error) => {
               console.error('Unable to load membership information.', error)
            })
            .finally(() => {
               this.isloading = false
            })
         })
      },

      onPaymentMounted() {
         if (this.memberinfo) {
            this.$refs.payment.setuserid(this.memberinfo.userid)
         }
      },

      onDeclMounted() {
         if (this.memberinfo) {
            this.$refs.decl.setuserid(this.memberinfo.userid)
         }
      },

      onCorpExpCompleted() {
         console.log('CorpExp completed')
      },

      onCorpExpMounted() {
         if (this.memberinfo) {
            this.$refs.corpexp.setuserid(this.memberinfo.userid)
         }
      },

      onEmpCatMounted() {
         if (this.memberinfo) {
            this.$refs.empcat.setuserid(this.memberinfo.userid)
         }
      },

      onEmpCatUpdated() {

      },

      onEmpExpMounted() {
         if (this.memberinfo) {
            this.$refs.empexp.setuserid(this.memberinfo.userid)
         }
      },

      onQualStuMounted() {
         if (this.memberinfo) {
            this.$refs.qualstu.setuserid(this.memberinfo.userid)
         }
      },

      onQualProMounted() {
         if (this.memberinfo) {
            this.$refs.qualpro.setuserid(this.memberinfo.userid)
         }
      },

      onQualEduMounted() {
         if (this.memberinfo) {
            this.$refs.qualedu.setuserid(this.memberinfo.userid)
         }
      },

      formatdatetime(e) {
         return this.$moment(new Date(e)).format('DD/MM/YYYY h:mm:ss A')
      },

      formatdate(e) {
         return this.$moment(new Date(e)).format('DD/MM/YYYY')
      },

      cleanValue(value) {
         return value === null || value === undefined || value === 'null' ? '' : value
      },

      loadform(pItem) {
         // general
         this.formmodelgeneral.memberid = (pItem.memberid) ? pItem.memberid : ''
         this.formmodelgeneral.lpbmcode = (pItem.lpbmcode) ? pItem.lpbmcode : ''
         this.formmodelgeneral.lpbmno = (pItem.lpbmno) ? pItem.lpbmno : ''
         this.formmodelgeneral.membertype = (pItem.membertype) ? pItem.membertype : ''
         this.formmodelgeneral.memberstatus = (pItem.memberstatus) ? pItem.memberstatus : ''
         this.formmodelgeneral.dateapplied = (pItem.dateapplied) ? this.formatdatetime(pItem.dateapplied) : ''
         this.formmodelgeneral.dateapproved = (pItem.dateapproved) ? this.formatdatetime(pItem.dateapproved) : ''
         this.formmodelgeneral.datepayment = (pItem.datepayment) ? this.formatdatetime(pItem.datepayment) : ''
         this.formmodelgeneral.datevalid = (pItem.datevalid) ? this.formatdate(pItem.datevalid) : ''

         const signupName = (this.user && this.user.name) ? this.user.name : ''
         const signupIc = (this.user && this.user.icpassport) ? this.user.icpassport : ''
         const signupEmail = (this.user && this.user.email) ? this.user.email : ''

         this.formmodel.sectdetails.fullname = this.cleanValue(pItem.fullname) || signupName
         this.formmodel.sectdetails.gender = this.cleanValue(pItem.gender)
         this.formmodel.sectdetails.nationality = this.cleanValue(pItem.nationality)
         this.formmodel.sectdetails.race = this.cleanValue(pItem.race)
         this.formmodel.sectdetails.religion = this.cleanValue(pItem.religion)
         this.formmodel.sectdetails.icpassport = this.formatIcPassport(this.cleanValue(pItem.icpassport) || signupIc)
         this.formmodel.sectdetails.dob = this.cleanValue(pItem.dob)
         this.formmodel.sectdetails.pob = this.cleanValue(pItem.pob)
         this.formmodel.sectdetails.contactmobile = this.cleanValue(pItem.contactmobile)
         this.formmodel.sectdetails.contactemail = this.cleanValue(pItem.contactemail) || signupEmail
         this.applyDobFromIc(this.formmodel.sectdetails.icpassport)

         this.formmodel.secthome.homestreet = this.cleanValue(pItem.homestreet)
         this.formmodel.secthome.homepostcode = this.cleanValue(pItem.homepostcode)
         this.formmodel.secthome.homecity = this.cleanValue(pItem.homecity)
         this.formmodel.secthome.homedistrict = this.cleanValue(pItem.homedistrict)
         this.formmodel.secthome.homestate = this.cleanValue(pItem.homestate)
         this.formmodel.secthome.homecountry = this.cleanValue(pItem.homecountry)
         this.formmodel.secthome.homephone = this.cleanValue(pItem.homephone)

         this.formmodel.sectwork.workcompany = this.cleanValue(pItem.workcompany)
         this.formmodel.sectwork.workjobtitle = this.cleanValue(pItem.workjobtitle)
         this.formmodel.sectwork.workdept = this.cleanValue(pItem.workdept)
         this.formmodel.sectwork.workposition = this.cleanValue(pItem.workposition)
         this.formmodel.sectwork.workstreet = this.cleanValue(pItem.workstreet)
         this.formmodel.sectwork.workpostcode = this.cleanValue(pItem.workpostcode)
         this.formmodel.sectwork.workcity = this.cleanValue(pItem.workcity)
         this.formmodel.sectwork.workdistrict = this.cleanValue(pItem.workdistrict)
         this.formmodel.sectwork.workstate = this.cleanValue(pItem.workstate)
         this.formmodel.sectwork.workcountry = this.cleanValue(pItem.workcountry)
         this.formmodel.sectwork.workphone = this.cleanValue(pItem.workphone)
         this.formmodel.sectwork.workfax = this.cleanValue(pItem.workfax)
         this.formmodel.sectwork.workemail = this.cleanValue(pItem.workemail)

         this.formmodel.sectcontactpref.prefercontacthome = pItem.prefercontacthome
         this.formmodel.sectcontactpref.prefercontactwork = pItem.prefercontactwork
         this.formmodel.sectcontactpref.prefercontactemail = pItem.prefercontactemail

         this.previewphoto = pItem.photolink
            ? "/" + String(pItem.photolink).replace(/^\/+/, '')
            : null
      },

      appendDetails(data) {
         data.append('userid', this.memberinfo.userid)
         data.append('fullname', this.formmodel.sectdetails.fullname)
         data.append('gender', this.formmodel.sectdetails.gender)
         data.append('nationality', this.formmodel.sectdetails.nationality)
         data.append('race', this.formmodel.sectdetails.race)
         data.append('religion', this.formmodel.sectdetails.religion)
         data.append('icpassport', this.formatIcPassport(this.formmodel.sectdetails.icpassport))
         data.append('dob', this.formmodel.sectdetails.dob)
         data.append('pob', this.formmodel.sectdetails.pob)
         data.append('contactmobile', this.formmodel.sectdetails.contactmobile)
         data.append('contactemail', this.formmodel.sectdetails.contactemail)
         data.append('homestreet', this.formmodel.secthome.homestreet)
         data.append('homepostcode', this.formmodel.secthome.homepostcode)
         data.append('homecity', this.formmodel.secthome.homecity)
         data.append('homedistrict', this.formmodel.secthome.homedistrict)
         data.append('homestate', this.formmodel.secthome.homestate)
         data.append('homecountry', this.formmodel.secthome.homecountry)
         data.append('homephone', this.formmodel.secthome.homephone)
         data.append('workcompany', this.formmodel.sectwork.workcompany)
         data.append('workjobtitle', this.formmodel.sectwork.workjobtitle)
         data.append('workdept', this.formmodel.sectwork.workdept)
         data.append('workposition', this.formmodel.sectwork.workposition)
         data.append('workstreet', this.formmodel.sectwork.workstreet)
         data.append('workpostcode', this.formmodel.sectwork.workpostcode)
         data.append('workcity', this.formmodel.sectwork.workcity)
         data.append('workdistrict', this.formmodel.sectwork.workdistrict)
         data.append('workstate', this.formmodel.sectwork.workstate)
         data.append('workcountry', this.formmodel.sectwork.workcountry)
         data.append('workphone', this.formmodel.sectwork.workphone)
         data.append('workfax', this.formmodel.sectwork.workfax)
         data.append('workemail', this.formmodel.sectwork.workemail)
         data.append('prefercontacthome', this.formmodel.sectcontactpref.prefercontacthome)
         data.append('prefercontactwork', this.formmodel.sectcontactpref.prefercontactwork)
         data.append('prefercontactemail', this.formmodel.sectcontactpref.prefercontactemail)
      },

      scheduleAutosave() {
         if (this.isloading || !this.memberinfo) {
            return
         }
         clearTimeout(this.autosaveTimer)
         this.autosaveTimer = setTimeout(() => {
            this.autosavedetails()
         }, 1200)
      },

      autosavedetails() {
         if (!this.memberinfo || this.autosaving) {
            return
         }
         const data = new FormData()
         this.appendDetails(data)
         this.autosaving = true
         axios.post('/member/autosavedetails', data)
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.memberinfo = resp.data.data
               this.txtmessage = 'Auto-saved'
               this.sbmessage = true
            }
         })
         .finally(() => {
            this.autosaving = false
         })
      },

      requestCorporateUpgrade() {
         if (!this.memberinfo) {
            return
         }
         const data = new FormData()
         data.append('userid', this.memberinfo.userid)
         data.append('course_date', this.upgradeForm.course_date)
         data.append('interview_date', this.upgradeForm.interview_date)
         data.append('exam_date', this.upgradeForm.exam_date)
         data.append('notes', this.upgradeForm.notes)
         if (this.upgradeForm.document) {
            data.append('document', this.upgradeForm.document)
         }
         this.submittingUpgrade = true
         axios.post('/member/apply/upgrade-corporate', data, {
            headers: {
               'Content-Type': 'multipart/form-data'
            }
         })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.memberinfo = resp.data.data
               this.txtmessage = 'Corporate upgrade request submitted'
               this.sbmessage = true
               this.dlgupgrade = false
               this.tab = 'T5'
               this.initialize()
            } else if (resp.data) {
               this.txtmessage = resp.data.error
               this.sbmessage = true
            }
         })
         .finally(() => {
            this.submittingUpgrade = false
         })
      },

      async updatemember() {
         var targetPath = "/member/update"

         if (this.photofile) {
            const photoOk = await this.validateSelectedPhoto(this.photofile)
            if (!photoOk) {
               return
            }
         }

         const data = new FormData()
         this.appendDetails(data)

         // optional fields
         if (this.formmodelgeneral.memberid) {
            data.append('memberid', this.formmodelgeneral.memberid)
         }

         if (this.formmodelgeneral.memberstatus) {
            data.append('memberstatus', this.formmodelgeneral.memberstatus)
         }

         if (this.formmodelgeneral.membertype) {
            data.append('membertype', this.formmodelgeneral.membertype)
         }

         if (this.formmodelgeneral.lpbmcode) {
            data.append('lpbmcode', this.formmodelgeneral.lpbmcode)
         }

         if (this.formmodelgeneral.lpbmno) {
            data.append('lpbmno', this.formmodelgeneral.lpbmno)
         }

         // photo
         if (this.photofile) {
            data.append('photolink', this.photofile)
         }

         axios.post(targetPath, data, {
            headers: {
               'Content-Type': 'multipart/form-data'
            }
         })
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.txtmessage = 'Membership information updated'
                  this.sbmessage = true
                  if (rtn.data) {
                     this.memberinfo = rtn.data
                     this.loadform(this.memberinfo)
                  }
                  if (rtn.profile_photo_url) {
                     this.previewphoto = rtn.profile_photo_url
                     if (this.$page && this.$page.user) {
                        this.$page.user.profile_photo_url = rtn.profile_photo_url
                     }
                  }
                  this.photofile = null
                  this.initialize()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

   },

   computed: {
      memberTitle() {
         if (!this.memberinfo) {
            return ''
         }

         const name = this.memberinfo.fullname || (this.user && this.user.name) || 'Member'
         const memberId = this.memberinfo.memberid

         return memberId ? `${name} [ ${memberId} ]` : name
      },

      photoValidationClass() {
         if (this.photoValidationState === 'success') {
            return 'green--text'
         }
         if (this.photoValidationState === 'error') {
            return 'red--text'
         }
         return 'grey--text'
      },

      canRequestCorporateUpgrade() {
         return this.memberinfo
            && this.memberinfo.membertype === 'GRA'
            && parseInt(this.memberinfo.memberstatus) === 3
            && ![1, 2, 3].includes(parseInt(this.memberinfo.applcorpstatus || 0))
      },

      memberTypeLabel() {
         const types = {
            HON: 'Honorary Fellow',
            COR: 'Corporate Member',
            FEL: 'Fellow',
            STU: 'Student Member',
            GRA: 'Graduate Member',
            ASC: 'Associate Member',
            PAT: 'Patron',
         }
         return types[this.memberinfo && this.memberinfo.membertype] || 'Member'
      },

      memberTypeColor() {
         const colors = {
            COR: 'teal darken-1',
            FEL: 'indigo darken-1',
            GRA: 'blue darken-1',
            STU: 'deep-purple darken-1',
            ASC: 'cyan darken-2',
            HON: 'amber darken-3',
            PAT: 'grey darken-2',
         }
         return colors[this.memberinfo && this.memberinfo.membertype] || 'blue-grey'
      },

      memberStatusLabel() {
         const status = {
            0: 'New Application',
            1: 'Pending Review',
            2: 'Pending Payment',
            3: 'Active',
            4: 'Inactive',
            5: 'Rejected',
            6: 'Incomplete',
            9: 'Suspended / Struck-Off',
         }
         return status[parseInt(this.memberinfo && this.memberinfo.memberstatus)] || 'Unknown Status'
      },

      memberStatusColor() {
         const status = parseInt(this.memberinfo && this.memberinfo.memberstatus)
         if (status === 3) return 'green darken-1'
         if (status === 2) return 'orange darken-2'
         if ([5, 9].includes(status)) return 'red darken-1'
         if (status === 6) return 'purple darken-1'
         return 'blue-grey darken-1'
      },

      lpbmDisplay() {
         const code = this.formmodelgeneral.lpbmcode || ''
         const no = this.formmodelgeneral.lpbmno || ''
         return (code || no) ? `${code}${no}` : '-'
      },

      profileCompletion() {
         const required = [
            this.formmodel.sectdetails.fullname,
            this.formmodel.sectdetails.icpassport,
            this.formmodel.sectdetails.contactemail,
            this.formmodel.sectdetails.contactmobile,
            this.formmodel.sectdetails.dob,
            this.formmodel.secthome.homestreet,
            this.formmodel.secthome.homepostcode,
            this.formmodel.secthome.homecity,
            this.formmodel.secthome.homestate,
            this.previewphoto,
         ]
         const completed = required.filter(value => !!value && value !== 'null').length
         return Math.round((completed / required.length) * 100)
      },

      generalCards() {
         return [
            { label: 'Member ID', value: this.formmodelgeneral.memberid || 'Not assigned', icon: 'mdi-card-account-details-outline' },
            { label: 'Member Type', value: this.memberTypeLabel, icon: 'mdi-account-badge-outline' },
            { label: 'Status', value: this.memberStatusLabel, icon: 'mdi-shield-check-outline' },
            { label: 'IC / Passport', value: this.formmodel.sectdetails.icpassport || '-', icon: 'mdi-identifier' },
            { label: 'Email', value: this.formmodel.sectdetails.contactemail || '-', icon: 'mdi-email-outline' },
            { label: 'Mobile', value: this.formmodel.sectdetails.contactmobile || '-', icon: 'mdi-cellphone' },
            { label: 'Home State', value: this.formmodel.secthome.homestate || '-', icon: 'mdi-map-marker-outline' },
            { label: 'Work Organisation', value: this.formmodel.sectwork.workcompany || '-', icon: 'mdi-domain' },
            { label: 'LPBM No.', value: this.lpbmDisplay, icon: 'mdi-certificate-outline' },
         ]
      },

      timelineCards() {
         return [
            { label: 'Date Applied', value: this.formmodelgeneral.dateapplied || '-' },
            { label: 'Date Approved', value: this.formmodelgeneral.dateapproved || '-' },
            { label: 'Date Payment', value: this.formmodelgeneral.datepayment || '-' },
            { label: 'Valid Until', value: this.formmodelgeneral.datevalid || '-' },
         ]
      }
   },

   mounted() {
      this.initialize()
   }

}
</script>

<style scoped>
.member-info-shell {
   background: #f8fafc;
   border: 1px solid #dfe5ee;
   border-radius: 8px;
   overflow: hidden;
   box-shadow: 0 8px 22px rgba(15, 23, 42, 0.08);
}

.member-info-hero {
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 24px;
   padding: 24px;
   background: linear-gradient(135deg, #0f766e 0%, #1d4ed8 100%);
}

.member-profile {
   display: flex;
   align-items: center;
   gap: 18px;
   min-width: 0;
}

.member-avatar {
   border: 3px solid rgba(255, 255, 255, 0.84);
   background: white;
}

.member-name {
   color: white;
   font-size: 28px;
   line-height: 1.2;
   font-weight: 700;
   margin: 0;
}

.member-meta {
   display: flex;
   flex-wrap: wrap;
   gap: 8px 16px;
   color: rgba(255, 255, 255, 0.86);
   font-size: 13px;
}

.member-actions {
   display: flex;
   flex-wrap: wrap;
   gap: 10px;
   justify-content: flex-end;
}

.member-summary-grid {
   display: grid;
   grid-template-columns: repeat(4, minmax(0, 1fr));
   gap: 1px;
   background: #dfe5ee;
   border-bottom: 1px solid #dfe5ee;
}

.summary-tile {
   min-height: 92px;
   padding: 18px 20px;
   background: white;
}

.summary-tile span,
.info-block span,
.timeline-block span {
   display: block;
   color: #64748b;
   font-size: 12px;
   font-weight: 700;
   letter-spacing: 0;
   text-transform: uppercase;
}

.summary-tile strong {
   display: block;
   color: #0f172a;
   font-size: 20px;
   line-height: 1.25;
   margin-top: 7px;
   word-break: break-word;
}

.member-tabs {
   background: white;
   border-bottom: 1px solid #e2e8f0;
}

.member-tabs ::v-deep .v-tab {
   letter-spacing: 0;
   text-transform: none;
   font-weight: 700;
}

.member-tab-panel {
   padding: 18px;
   background: #f8fafc;
}

.info-block,
.timeline-block {
   display: flex;
   align-items: flex-start;
   gap: 14px;
   height: 100%;
   min-height: 92px;
   padding: 16px;
   background: white;
   border: 1px solid #e2e8f0;
   border-radius: 8px;
}

.info-block-icon {
   display: flex;
   align-items: center;
   justify-content: center;
   width: 38px;
   height: 38px;
   border-radius: 8px;
   background: #e0f2fe;
   color: #0369a1;
   flex: 0 0 auto;
}

.info-block strong,
.timeline-block strong {
   display: block;
   color: #111827;
   font-size: 15px;
   line-height: 1.35;
   margin-top: 6px;
   word-break: break-word;
}

.section-title {
   color: #334155;
   font-size: 13px;
   font-weight: 800;
   letter-spacing: 0;
   margin: 22px 0 10px;
   text-transform: uppercase;
}

.timeline-block {
   display: block;
   min-height: 82px;
}

@media (max-width: 960px) {
   .member-info-hero {
      align-items: flex-start;
      flex-direction: column;
   }

   .member-actions {
      justify-content: flex-start;
      width: 100%;
   }

   .member-summary-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
   }
}

@media (max-width: 600px) {
   .member-profile {
      align-items: flex-start;
   }

   .member-name {
      font-size: 22px;
   }

   .member-summary-grid {
      grid-template-columns: 1fr;
   }
}
</style>
